<template>
  <div style="height: 10%">
    <van-nav-bar :loading="loading" :right-text="username" left-arrow left-text="返回" title="零货作业" @click-left="onClickLeft" @click-right="goIndex()" />
    <div style="height: 90%">
      <van-col span="18">
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.location.no" label="货位" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.sumQuantity" label="剩余库存" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.item.no" label="商品编号" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.item.name" error label="通用名称" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.pack.specification" label="包装规格" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.pack.uom" label="计量单位" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.pack.factor" label="包装数量" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.pack.innerFactor" label="中包装数量" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.lot.no" error label="批号" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.validity" label="效期" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.lot.manufacturer" label="生产厂商" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.lot.producingArea" label="产地" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-cell center style="font-size: large" title="拆中包装">
              <van-switch slot="right-icon" v-model="detail.item.scattered" active-color="#07c160" disabled inactive-color="#dcdee0" size="24" />
            </van-cell>
          </van-col>
          <van-col span="12">
            <van-cell center style="font-size: large" title="追加">
              <van-switch slot="right-icon" v-model="detail.appending" active-color="#07c160" inactive-color="#dcdee0" size="24" />
            </van-cell>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.numberOfCase" error label="计划数量" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.numberOfCase2" clearable error label="实际数量" style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="detail.orderType.name" label="订单类型" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="detail.customer.name" label="客户名称" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="12">
            <van-field v-model="last.location.no" label="上次货位" readonly style="font-size: large" />
          </van-col>
          <van-col span="12">
            <van-field v-model="last.container.no" label="上次箱号" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="8">
            <van-field v-model="last.item.name" label="上次商品" readonly style="font-size: large" />
          </van-col>
          <van-col span="8">
            <van-field v-model="last.lot.no" label="上次批号" readonly style="font-size: large" />
          </van-col>
          <van-col span="8">
            <van-field v-model="last.numberOfCase2" label="上次数量" readonly style="font-size: large" />
          </van-col>
        </van-row>
        <van-tabbar style="width: 70%">
          <van-tabbar-item align="center">
            <van-button :loading="loading" block round style="margin: 8px;width: 200px" type="primary" @click="Confirm">确认</van-button>
          </van-tabbar-item>
        </van-tabbar>
      </van-col>
      <van-col class="main-pick" span="6">
        <van-row style="height:40%">
          <div class="pick-right">
            <div class="pick-right-top">
              <div>
                <div class="location-box blue">
                  <div id="location-box_container_number1"></div>
                  <div id="location-box_container_no1"></div>
                </div>
              </div>
              <div>
                <div class="location-box blue">
                  <div id="location-box_container_number2"></div>
                  <div id="location-box_container_no2"></div>
                </div>
              </div>
              <div>
                <div class="location-box blue">
                  <div id="location-box_container_number3"></div>
                  <div id="location-box_container_no3"></div>
                </div>
              </div>

              <div>
                <div class="location-box blue">
                  <div id="location-box_container_number4"></div>
                  <div id="location-box_container_no4"></div>
                </div>
              </div>
            </div>
          </div>
        </van-row>
        <van-row style="height:60%">
          <vxe-table
            border
            ref="tab1"
            round
            :data="list"
            show-overflow
            :keyboard-config="{isArrow: true}"
            :loading="loading"
            :row-config="{isCurrent: true, isHover: true}"
            :column-config="{resizable: true}"
            :scroll-x="{enabled: true}"
            align="center"
            size="mini"
            show-header-overflow
            @cell-click="onLocationClicked()"
            stripe>
            <vxe-column fixed="left" type="seq" width="40"/>
            <vxe-column field="location.no" title="货位" />
          </vxe-table>
        </van-row>
      </van-col>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/api'
import { findAll, findOne, post } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import moment from 'moment'
import { Toast } from 'vant'
import { getUser } from '@/pdaView/utils'
import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'

export default {
    name: 'Picking',
    data() {
      return {
        loading: false,
        finished: false,
        username: getUser().name,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.4),
        taskGroup: this.$route.params.taskGroup,
        containers: this.$route.params.containers,
        selectedRowKeys: [],
        selectedRows: {},
        detail: new ShippingFactoryView(),
        last: {
          location: { no: '' },
          container: { no: '' },
          item: { name: '' },
          lot: { no: '' },
          numberOfCase2: ''
        },
        list: []
      }
    },
    activated() {
      this.refresh()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PadIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      onLocationClicked(cell) {
        this.loading = true
        let locationId = null
        if (typeof cell === 'string') {
          locationId = cell
        } else {
          locationId = this.$refs.tab1.getCurrentRecord().location.id
        }
        findOne('pickingTaskDetailFactory', { each: true, taskGroup: this.taskGroup, 'location.id': locationId }).then(res => {
          if (res.success && res.result) {
            this.detail = {
              ...res.result,
              appending: res.result.command.appendageSign === 1,
              numberOfCase: res.result.item.scattered ? res.result.command.plannedQuantity : res.result.command.plannedQuantity / res.result.pack.innerFactor,
              numberOfCase2: res.result.item.scattered ? res.result.command.actualQuantity : res.result.command.plannedQuantity / res.result.pack.innerFactor,
              validity: moment(res.result.lot.productionDate).format('YYYY-MM-DD') + '--' + moment(res.result.lot.validUntil).format('YYYY-MM-DD')
            }
            let isIndexArr = []
            this.containers.map(item => {
              if (this.detail.container.no === item.container.no) {
                let indexArr
                let location = '#location-box_container_number' + item.index
                let color = 'location-box_container_number' + item.index
                indexArr = this.containers.filter(data => data.index !== item.index)
                isIndexArr = indexArr
                $('#container_no').text(item.container.no)
                $('#container_number').text(this.detail.numberOfCase2)
                $(location).text(this.detail.numberOfCase2)
                document.getElementById(color).style.backgroundColor = '#db5860'
              }
            })
            isIndexArr.map(item2 => {
              let location = '#location-box_container_number' + item2.index
              let color = 'location-box_container_number' + item2.index
              $(location).text('')
              document.getElementById(color).style.backgroundColor = '#339cfc'
            })
          } else {
            this.onClickLeft()
          }
        }).finally(() => this.loading = false)
      },
      refresh() {
        if (this.containers[0]) {
          $('#location-box_container_no1').text('A->' + this.containers[0].container.no)
        }
        if (this.containers[1]) {
          $('#location-box_container_no2').text('B->' + this.containers[1].container.no)
        }
        if (this.containers[2]) {
          $('#location-box_container_no3').text('C->' + this.containers[2].container.no)
        }
        if (this.containers[3]) {
          $('#location-box_container_no4').text('D->' + this.containers[3].container.no)
        }
        this.getLocations()
      },
      getLocations() {
        this.loading = true
        findAll('pickingObtainedGroupLocationFactory', { 'taskGroup': this.taskGroup }).then(res => {
          if (res.success) {
            if (res.result.length > 0) {
              this.$refs.tab1.setRadioRow(res.result[0])
              this.list = res.result
              this.onLocationClicked(res.result[0].location.id)
            } else {
              this.goIndex()
            }
          }
        }).finally(() => this.loading = false)
      },
      Confirm() {
        if (this.detail.numberOfCase2 > this.detail.numberOfCase) {
          Toast('实际数量不能大于计划数量！')
          return
        }
        this.loading = true
        const args = {
          'pickingOrder.id': this.detail.pickingOrder.id,
          commandGroup: this.detail.command.commandGroup
        }
        if (this.detail.numberOfCase > this.detail.numberOfCase2) {
          args.actualQuantity = this.detail.numberOfCase2 * this.detail.pack.innerFactor
          args.appendageSign = this.detail.appending === true ? 1 : 3
        }
        post(api.pickingConfirm, { type: 'shipmentCommandConfirmer' }, args).then(res => {
          if (res.success) {
            Toast('确认成功！')
            this.last = this.detail
            this.getLocations()
          }
        }).finally(() => this.loading = false)
      }
    }
  }
</script>
<style scoped>
  .field_color .van-field__label {
    color: red;
  }

  .main-pick .pick-list {
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 0 5px
  }

  .main-pick .pick-list-box > .x-body-el {
    overflow: auto;
  }

  .main-pick .pick-list .item {
    height: 35px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
  }

  .pick-center .pick-center-top {
    display: flex;
    flex-direction: row;
  }

  .pick-center .pick-center-right-top {
    display: flex;
    flex-direction: row;
    text-align: -webkit-right;
  }

  .main-pick .pick-location {
    width: 130px;
    height: 90px;
    margin: 5px;
    border: 1px solid #f15353;
    border-radius: 4px
  }

  .main-pick .pick-location1 {
    width: 50px;
    height: 90px;
    margin: 5px;
    border: 1px solid #f15353;
    border-radius: 4px
  }

  .main-pick .pick-location div:nth-child(1) {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 40px;
    background: #339cfc;
    color: #fff;
  }

  .main-pick .pick-location1 div:nth-child(1) {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 25px;
    background: #339cfc;
    color: #fff;
  }

  .main-pick .pick-location div:nth-child(2) {
    text-align: center;
    line-height: 36px;
    font-size: 30px;
  }

  .main-pick-pick .pick-location1 div:nth-child(2) {
    text-align: center;
    line-height: 36px;
    font-size: 30px;
  }

  .pick-center .pick-center-top .pick-location-num {
    flex: 1;
    padding: 7px 0 0 0;
  }

  .pick-center .pick-center-right-top .pick-location1-num {
    flex: 1;
    padding: 7px 0 0 0;
  }

  .main-pick .row-item {
    padding-bottom: 8px;
    display: flex;
    flex-direction: row;
  }

  .main-pick .row-item label {
    height: 35px;
    line-height: 35px;
    padding: 0 6px 0 10px;
    font-size: 14px;
    min-width: 78px;
  }

  .main-pick .row-item input {
    flex: 1;
    height: 35px;
    line-height: 35px;
    border: 1px solid #dcdcdc;
    padding-left: 10px
  }

  .main-pick .row-item input:focus {
    outline: none;
  }

  .main-pick .row-item input[readonly] {
    background: #ededed;
  }

  .main-pick .pick-location-num .row-item input {
    text-align: right;
    padding-right: 10px;
  }

  .main-pick .row-item.red label {
    color: #f15353;
  }

  .main-pick .row-item.red input {
    color: #f15353;
    border-color: #f4c0c0;
    font-size: 18px;
    font-weight: bold;
  }

  .main-pick .pick-form {
    padding-right: 10px
  }

  .main-pick .pick-laction-unit {
    width: 60px;
    line-height: 80px;
    height: 80px;
    padding-top: 7px;
    text-align: center;
    font-size: 30px;
    color: #f15353;
  }

  .main-pick .pick-right .pick-form {
    padding-top: 8px;
  }

  .main-pick .pick-right .pick-form .row-item {
    box-sizing: border-box;
  }

  .main-pick .row-item input.blue {
    color: #0e0ed5;
    font-size: 18px;
    font-weight: bold;
    width: 100%;
  }

  .main-pick .pick-right-top {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .main-pick .pick-right-top > div {
    width: 50%;
    padding: 5px
  }

  .main-pick .location-box {
    height: 125px;
    border: 1px solid #b7b1b1;
    border-radius: 4px
  }

  .main-pick .location-box div:nth-child(1) {
    height: 85px;
    line-height: 76px;
    text-align: center;
    font-size: 56px;
  }

  .main-pick .location-box div:nth-child(2) {
    text-align: center;
    line-height: 35px;
    font-size: 20px;
  }

  .main-pick .location-box.blue {
    border: 1px solid #339cfc;
  }

  .main-pick .location-box.blue div:nth-child(1) {
    background: #339cfc;
    color: #fff;
  }
</style>